import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getScopedModuleIds, isEmailProductModule, isEmailCartModule, getWidgetIdsToAlwaysRenderWithV3, getIsModuleDefault
// @ts-expect-error Cannot find declaration for module
} from 'EmailEditorUI/utils/moduleUtils';
// @ts-expect-error Cannot find declaration for module
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
import { getIsEmailTemplate } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { getIsAutomated, getIsAbLike
// @ts-expect-error Cannot find declaration for module
} from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { getIsUngatedForAssetLevelHublSupport } from 'EmailEditorUI/redux/selectors/AuthSelectors';

// @ts-expect-error Cannot find declaration for module
import ElementTile from 'LayoutBuilderUI/components/tiles/ElementTile';
import DisabledModuleMessage from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/DisabledModuleMessage';
import ExpandableSectionContentWrapper from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/ExpandableSectionContentWrapper';
import { getTooltipPlacement } from 'LayoutBuilderUI/components/panels/sidebar/utils/tooltips';
import { useModulesSectionShowMoreProperties } from 'LayoutBuilderUI/components/panels/sidebar/hooks/useModulesSectionShowMoreProperties';
import EmailV3RenderingTooltipMessage from 'LayoutBuilderUI/components/extras/EmailV3RenderingTooltipMessage';
import CustomModuleTile from 'LayoutBuilderUI/components/tiles/CustomModuleTile';

// @ts-expect-error Cannot find declaration for module
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SingleModule = ({
  moduleSpec,
  index,
  withStoringInRecentlyUsed
}) => {
  const dispatch = useDispatch();
  const scopedModules = useSelector(getScopedModuleIds);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const isAutomated = useSelector(getIsAutomated);
  const isEmailTemplate = useSelector(getIsEmailTemplate);
  const isAbLike = useSelector(getIsAbLike);
  const isUngatedForAssetLevelHublSupport = useSelector(getIsUngatedForAssetLevelHublSupport);
  const id = moduleSpec.moduleId;
  const isTileLocked = scopedModules.includes(id);
  const isCustomModuleSpec = !getIsModuleDefault(moduleSpec);
  const specName = isCustomModuleSpec && moduleSpec.displayName;
  const isDisabledForNonAutomatedEmails = !isAutomated && !isEmailTemplate && getWidgetIdsToAlwaysRenderWithV3().includes(id);
  const disabled = isReadOnlyMode || isTileLocked || isDisabledForNonAutomatedEmails;
  const isProgrammableEmailModule = isUngatedForAssetLevelHublSupport && moduleSpec.isEnabledForEmailV3Rendering;
  const moduleRibbonTooltipTitle = isProgrammableEmailModule && /*#__PURE__*/_jsx(EmailV3RenderingTooltipMessage, {});
  const maybeOpenPql = useCallback(() => {
    if (!isTileLocked) {
      return;
    }
    if (isEmailProductModule(id)) {
      dispatch(openModal(MODAL_TYPES.PRODUCTS_MODULE_PQL));
    }
    if (isEmailCartModule(id)) {
      dispatch(openModal(MODAL_TYPES.CART_MODULE_PQL));
    }
  }, [dispatch, id, isTileLocked]);
  return /*#__PURE__*/_jsx(ElementTile, {
    moduleSpec: moduleSpec,
    dispatch: dispatch,
    disabled: disabled,
    disabledMessage: disabled && /*#__PURE__*/_jsx(DisabledModuleMessage, {
      isDisabledForNonAutomatedEmails: isDisabledForNonAutomatedEmails,
      isAbLike: isAbLike
    }),
    elementType: "custom",
    elementData: moduleSpec,
    label: specName,
    showBetaRibbon: isProgrammableEmailModule,
    tooltipPlacement: getTooltipPlacement(index),
    moduleRibbonTooltipTitle: moduleRibbonTooltipTitle,
    isLocked: isTileLocked,
    withStoringInRecentlyUsed: withStoringInRecentlyUsed,
    onClick: maybeOpenPql
  }, moduleSpec.moduleId);
};
const RenderModules = ({
  children,
  modules,
  isPaymentModuleVisible,
  isCustom = false,
  withStoringInRecentlyUsed
}) => {
  const {
    setShouldShowAll,
    shouldRenderShowMore,
    displayedItems
  } = useModulesSectionShowMoreProperties(modules);
  if (isCustom) {
    return /*#__PURE__*/_jsx(ExpandableSectionContentWrapper, {
      numberOfTiles: displayedItems.length,
      shouldRenderShowMore: shouldRenderShowMore,
      onShowMoreClick: () => setShouldShowAll(true),
      children: /*#__PURE__*/_jsx(Flex, {
        inlineSize: "100%",
        paddingBlockEnd: shouldRenderShowMore ? '0' : '300',
        flexDirection: "column",
        gap: "200",
        children: displayedItems.map(moduleSpec => {
          return /*#__PURE__*/_jsx(CustomModuleTile, {
            elementData: moduleSpec
          }, moduleSpec.id);
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(ExpandableSectionContentWrapper, {
    numberOfTiles: displayedItems.length + (isPaymentModuleVisible ? 1 : 0),
    shouldRenderShowMore: shouldRenderShowMore,
    onShowMoreClick: () => setShouldShowAll(true),
    children: [displayedItems.map((moduleSpec, idx) => /*#__PURE__*/_jsx(SingleModule, {
      index: idx,
      moduleSpec: moduleSpec,
      withStoringInRecentlyUsed: withStoringInRecentlyUsed
    }, idx)), children]
  });
};
export default RenderModules;